import { Fragment } from 'react';
import { Formprops } from './Forgotpassword.types';
import Spinner from '../../../components/Spinner/Spinner';
import { Link } from 'react-router-dom';

const Forgotpasswordform = ({ register, formState: { errors, isSubmitting } }: Formprops) => {
  return (
    <Fragment>
      <label className="form-label" htmlFor="email">
        Correo Institucional
      </label>
      <input
        className={`form-input${errors.email ? ' form-input-invalid' : ''}`}
        type="email"
        id="email"
        autoComplete="email"
        aria-invalid={Boolean(errors.email)}
        aria-describedby={errors.email ? 'forgot-email-error' : undefined}
        {...register('email', {
          required: {
            value: true,
            message: 'Este campo es requerido',
          },
          pattern: {
            value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
            message: 'Ingrese un correo válido',
          },
        })}
      />
      <p className="form-input-error-message" id="forgot-email-error">{errors.email?.message}</p>
      <button className="form-button" type="submit" disabled={isSubmitting} aria-busy={isSubmitting}>
        {isSubmitting ? <><Spinner label="Enviando instrucciones" /><span>Enviando…</span></> : 'Enviar instrucciones'}
      </button>
      <Link to="/login" className="form-link">Volver a iniciar sesión</Link>
    </Fragment>
  );
};

export default Forgotpasswordform;
